var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatwest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#281D46",
    d: "M28.5 57a28.5 28.5 0 1 0 0-57 28.5 28.5 0 0 0 0 57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F47A64",
    d: "m33.2 29.7.2.1.3-.1 4.1-7.1a1 1 0 0 0 0-1l-4-6.9c-.2-.3-.6-.5-1-.5h-.3l-3.8 7.7.7 1.2 3.8 6.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED232F",
    d: "M29.4 21.2 33 15a.6.6 0 0 0-.5-.8h-7.7a1 1 0 0 0-.9.4l-4 7.2c-.1 0-.1.1 0 .2l.1.1h7.8c.6 0 1.2.4 1.6 1a2 2 0 0 1 0-1.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F47A64",
    d: "M26.6 26v-.3l-.2-.1h-8.2a1 1 0 0 0-.9.4l-4 7c-.2.3-.2.7 0 1l.2.4 8.7-.8.6-1 3.8-6.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED232F",
    d: "M21.2 33.5h-7.5c-.3.2-.4.6-.2.9l3.8 6.6c.2.3.5.5.9.5h8.2c.1 0 .2 0 .2-.2v-.2l-3.8-6.7c-.4-.6-.3-1.3 0-1.8-.3.5-1 .9-1.6.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F47A64",
    d: "m26.7 33.5-.2.1v.3l4.1 7c.2.4.5.6.9.6h8c.3 0 .7-.2 1-.6l.1-.3-3.6-7.1H26.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED232F",
    d: "m36 34.4 3.6 6.2.2.2c.3.2.6 0 .8-.2l3.8-6.6a1 1 0 0 0 0-1l-4-7c-.1-.2-.2-.2-.3-.2l-.2.1-3.9 6.7c-.3.5-1 .9-1.6.9a2 2 0 0 1 1.6.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatwest);
export default __webpack_public_path__ + "static/media/Natwest.d71312bc7b7004c2f7db21f3c0b98e32.svg";
export { ForwardRef as ReactComponent };